import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05d19ae9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lb-header-avatar" }
const _hoisted_2 = { class: "lb-header-username" }
const _hoisted_3 = { class: "font-comfortaa-b" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-pwd" })
], -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 修改密码 ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-logout" })
], -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 退出登录 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout_header, { class: "lb-shadow" }),
    _createVNode(_component_a_layout_header, {
      class: "lb-header",
      style: _normalizeStyle({ left: _ctx.left + 'px' })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb, {
          class: "lb-header-breadcrumb",
          routes: _ctx.routes
        }, null, 8, ["routes"]),
        _createVNode(_component_a_dropdown, { placement: "bottomRight" }, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, { onClick: _ctx.editPwd }, {
                  icon: _withCtx(() => [
                    _hoisted_4
                  ]),
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_menu_divider),
                _createVNode(_component_a_menu_item, { onClick: _ctx.logout }, {
                  icon: _withCtx(() => [
                    _hoisted_6
                  ]),
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_a_avatar, {
                shape: "square",
                style: _normalizeStyle({
            background: _ctx.avatars[_ctx.userType].color,
            verticalAlign: 'middle',
          })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.avatars[_ctx.userType].name), 1)
                ]),
                _: 1
              }, 8, ["style"]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.username), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["style"]),
    _createVNode(_component_a_modal, {
      title: "修改密码",
      centered: "",
      visible: _ctx.pwdShow,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pwdShow) = $event)),
      "confirm-loading": _ctx.pwdLoading,
      onOk: _ctx.pwd
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "horizontal" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, _mergeProps({
              label: "原密码",
              name: "old"
            }, _ctx.pwdValidateInfos.old), {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.pwdValues.old,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pwdValues.old) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({
              label: "新密码",
              name: "new"
            }, _ctx.pwdValidateInfos.new), {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.pwdValues.new,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pwdValues.new) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_a_form_item, _mergeProps({
              label: "重复密码",
              name: "rpt"
            }, _ctx.pwdValidateInfos.rpt), {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.pwdValues.rpt,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pwdValues.rpt) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "onOk"])
  ], 64))
}